/**
 * Synthetic winter-storm warning for the Government of Ontario demo.
 * There is no live ECCC feed behind this — the ring covers the GTA and
 * the track reads as a system approaching Toronto from Georgian Bay.
 */

export const ONTARIO_GTA_STORM_LAYER_NAME =
  'Winter storm warning — approaching GTA';

export const ONTARIO_GTA_STORM_LAYER_DESCRIPTION =
  'Synthetic Environment Canada winter storm warning covering the Greater Toronto Area. Approach track from Georgian Bay toward downtown Toronto.';

export const ONTARIO_GTA_STORM_WARNING_NAME = 'Winter storm warning area';

export const ONTARIO_GTA_STORM_WARNING_DESCRIPTION =
  'Heavy snowfall, blowing snow and dangerous wind chill across the GTA.';

export const ONTARIO_GTA_STORM_TRACK_NAME = 'Storm track — approaching Toronto';

export const ONTARIO_GTA_STORM_TRACK_DESCRIPTION =
  'Forecast motion from Georgian Bay through Barrie into downtown Toronto.';

export const ONTARIO_GTA_STORM_POLYGON_COLOR = '#93c5fd';
export const ONTARIO_GTA_STORM_POLYGON_OPACITY = 0.35;

/** Downtown Toronto — the track should finish here. */
export const ONTARIO_GTA_STORM_TRACK_END: [number, number] = [-79.38, 43.65];

/**
 * Closed SW–NE snow band from Georgian Bay / Barrie through the GTA.
 * Coordinates are [lon, lat] and include all ONTARIO_GTA_FACILITIES.
 */
export const ONTARIO_GTA_STORM_WARNING_RING: number[][] = [
  [-80.2, 44.8],
  [-79.4, 44.9],
  [-78.8, 44.4],
  [-78.7, 43.75],
  [-78.9, 43.48],
  [-79.6, 43.45],
  [-80.05, 43.58],
  [-80.3, 44.2],
  [-80.35, 44.6],
  [-80.2, 44.8],
];

/** NW → SE approach into downtown Toronto. */
export const ONTARIO_GTA_STORM_TRACK: number[][] = [
  [-80.1, 44.75],
  [-79.9, 44.52],
  [-79.7, 44.39],
  [-79.55, 44.15],
  [-79.45, 43.88],
  ONTARIO_GTA_STORM_TRACK_END,
];
